import React from 'react';
import { EXERCISE_TYPES, RadioRow } from './exercise/shared';
import {
  CustomExerciseForm,
  CodingExerciseForm,
  HumanDataForm,
  SpeechToTextForm,
  McqForm,
  BigFiveForm,
  OnTheFlyForm,
} from './exercise/forms';

const FORM_MAP = {
  'custom': CustomExerciseForm,
  'coding': CodingExerciseForm,
  'human-data': HumanDataForm,
  'speech-to-text': SpeechToTextForm,
  'mcq': McqForm,
  'big-five': BigFiveForm,
  'on-the-fly': OnTheFlyForm,
};

export default function ExercisePanel({ module, onChange }) {
  const selected = module.exerciseType || 'custom';
  const FormComponent = FORM_MAP[selected] || CustomExerciseForm;

  return (
    <div>
      <div className="space-y-2.5">
        {EXERCISE_TYPES.map((t) => (
          <RadioRow
            key={t.id}
            t={t}
            selected={selected}
            onSelect={(id) => onChange({ exerciseType: id })}
          />
        ))}
      </div>
      <div className="mt-6">
        <FormComponent module={module} onChange={onChange} />
      </div>
    </div>
  );
}
